import React, { useEffect } from 'react';
import { useAuth } from './AuthProvider';

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg, #1e3a5f 0%, #0d1b2a 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },
  card: {
    background: 'white',
    borderRadius: '16px',
    boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
    padding: '48px',
    textAlign: 'center',
  },
  spinner: {
    width: '48px',
    height: '48px',
    border: '4px solid #e2e8f0',
    borderTopColor: '#3b82f6',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
    margin: '0 auto 24px',
  },
  text: {
    fontSize: '18px',
    color: '#1e3a5f',
    fontWeight: '500',
  },
};

function AuthCallback() {
  const { isAuthenticated, loading } = useAuth();

  useEffect(() => {
    // MSAL handles the redirect automatically
    // This component just shows a loading state
    if (isAuthenticated && !loading) {
      // Redirect to home after successful auth
      window.location.href = '/';
    }
  }, [isAuthenticated, loading]);

  return (
    <div style={styles.container}>
      <style>
        {`
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
        `}
      </style>
      <div style={styles.card}>
        <div style={styles.spinner}></div>
        <p style={styles.text}>Completing sign in...</p>
      </div>
    </div>
  );
}

export default AuthCallback;
